// extracted by mini-css-extract-plugin
export default {"table_wrapper":"paymentTable_table_wrapper__G885E","total":"paymentTable_total__8mxZ1"};